import { render, staticRenderFns } from "./Spade.vue?vue&type=template&id=3f7ed451&scoped=true&"
import script from "./Spade.vue?vue&type=script&lang=js&"
export * from "./Spade.vue?vue&type=script&lang=js&"
import style0 from "./Spade.vue?vue&type=style&index=0&id=3f7ed451&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f7ed451",
  null
  
)

export default component.exports